import { render } from "./OverviewContrats.vue?vue&type=template&id=567c52d8"
import script from "./OverviewContrats.vue?vue&type=script&lang=ts"
export * from "./OverviewContrats.vue?vue&type=script&lang=ts"
script.render = render

export default script